// Centralized route constants for the entire application.
// All navigation should reference these constants instead of hardcoded strings.

export const ROUTES = {
  ROOT: "/",
  AUTH: "/auth",
  RESET_PASSWORD: "/reset-password",

  // Billing
  BILLING_AUTH: "/billing/auth",
  BILLING: "/billing",
  BILLING_CLAIMS: "/billing/claims",
  BILLING_PAYERS: "/billing/payers",
  BILLING_REPORTS: "/billing/reports",
  BILLING_AGING: "/billing/aging",
  BILLING_DENIALS: "/billing/denials",
  BILLING_SETTINGS: "/billing/settings",
  BILLING_HELP: "/billing/help",
  BILLING_COMPLIANCE: "/billing/compliance",
  BILLING_PROVIDERS: "/billing/providers",
  BILLING_ASSIGNMENTS: "/billing/assignments",

  // Provider
  PROVIDER: "/provider",
  PROVIDER_ONBOARDING: "/provider/onboarding",
  PROVIDER_PATIENTS: "/provider/patients",
  PROVIDER_CASES: "/provider/cases",
  PROVIDER_PATIENT: "/provider/patient/:patientId",
  PROVIDER_SCHEDULE: "/provider/schedule",
  PROVIDER_TELEHEALTH: "/provider/telehealth",
  PROVIDER_SESSION_NOTES: "/provider/session/:sessionId/notes",
  PROVIDER_MONITORING: "/provider/monitoring",
  PROVIDER_CARE_PLANS: "/provider/care-plans",
  PROVIDER_PNCC: "/provider/pncc",
  PROVIDER_INTAKE: "/provider/intake",
  PROVIDER_PRENATAL_INTAKE: "/provider/prenatal-intake",
  PROVIDER_HEALTH_SEARCH_ANALYTICS: "/provider/health-search-analytics",
  PROVIDER_PROFILE: "/provider/profile",
  PROVIDER_SETTINGS: "/provider/settings",
  PROVIDER_HELP: "/provider/help",

  // Member
  MEMBER: "/member",
  MEMBER_ONBOARDING: "/member/onboarding",
  MEMBER_HEALTH: "/member/health",
  MEMBER_SCHEDULE: "/member/schedule",
  MEMBER_APPOINTMENTS: "/member/appointments",
  MEMBER_NOTIFICATIONS: "/member/notifications",
  MEMBER_DEVICES: "/member/devices",
  MEMBER_HEALTH_FAQ: "/member/health-faq",
  MEMBER_BILLING: "/member/billing",
  MEMBER_INSURANCE: "/member/insurance",
  MEMBER_PROFILE: "/member/profile",
  MEMBER_INTAKE: "/member/intake",
  MEMBER_SETTINGS: "/member/settings",
  MEMBER_HELP: "/member/help",

  // Telehealth
  TELEHEALTH_WAITING: "/telehealth/waiting/:sessionId",
  TELEHEALTH_SESSION: "/telehealth/session",
  TELEHEALTH_SESSION_ID: "/telehealth/session/:sessionId",
} as const;

// Helper functions for dynamic route paths
export const buildProviderPatientPath = (patientId: string) =>
  `/provider/patient/${patientId}` as const;

export const buildProviderSessionNotesPath = (sessionId: string) =>
  `/provider/session/${sessionId}/notes` as const;

export const buildTelehealthWaitingPath = (sessionId: string) =>
  `/telehealth/waiting/${sessionId}` as const;

export const buildTelehealthSessionPath = (sessionId: string) =>
  `/telehealth/session/${sessionId}` as const;
